// extracted by mini-css-extract-plugin
export var phone = "_3q-0";
export var phoneDragging = "_3q-1";